export const GET_PREP_PLAN_REPORTS = 'GET_PREP_PLAN_REPORTS';
export const SET_PREP_PLAN_REPORTS = 'SET_PREP_PLAN_REPORTS';
export const API_ERROR = 'LOGIN_API_ERROR';
export const DELETE_PREP_PLAN_REPORT = 'DELETE_PREP_PLAN_REPORT';
export const SET_PREP_PLAN_REPORT_FILTER = 'SET_PREP_PLAN_REPORT_FILTER';
export const GET_PREP_PLAN_REPORTS_LIST = 'GET_PREP_PLAN_REPORTS_LIST';
export const SET_PREP_PLAN_REPORTS_LIST = 'SET_PREP_PLAN_REPORTS_LIST';